import i18n from "i18next";

export const relativeTime = (iso) => {
  const sec = Math.round((new Date(iso).getTime() - Date.now()) / 1000);
  const [unit, size] = [
    ["day", 86400],
    ["hour", 3600],
    ["minute", 60],
  ].find(([, s]) => Math.abs(sec) >= s) || ["second", 1];
  return new Intl.RelativeTimeFormat(i18n.language, { numeric: "auto" }).format(
    Math.round(sec / size),
    unit
  );
};
